+<template>
  <section>
    <v-layout row justify-center align-center class="my-3">
      <v-flex xs12 md8>
        <v-icon class="my-1" color="primary">account_box</v-icon>&nbsp;&nbsp;<span class="txt-titulo">Datos Generales</span>
      </v-flex>
    </v-layout>
    <v-stepper v-model="e6" vertical class="elevation-6">
      <v-stepper-step :complete="e6 > '1'" step="1" :editable='true' @click='changeStep()'>Datos de la Declaración</v-stepper-step>
      <v-stepper-content step="1">
        <!-- <v-card color="grey lighten-1" class="mb-5" height="800px"></v-card> -->
        <datos-declaracion v-if="e6 === '1'"></datos-declaracion>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="accent" @click="e6 = '2'; changeStep();"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '2'" step="2" :editable='true' @click='changeStep()'>Datos Personales del Declarante</v-stepper-step>
      <v-stepper-content step="2">
        <datos-personales v-if="e6 === '2'"></datos-personales>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '1'; changeStep();"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
          <v-btn color="accent" @click="e6 = '3'; changeStep();"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '3'" step="3" :editable='true' @click='changeStep()' clic>Cargo que Ocupa(rá)</v-stepper-step>
      <v-stepper-content step="3">
        <cargo-ocupara v-if="e6 === '3'"></cargo-ocupara>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '2'; changeStep();"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
          <v-btn color="accent" @click="e6 = ee ; changeStep();"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '4'" step="4" :editable='edita'>Datos del Cónyuge o Conviviente</v-stepper-step>
      <v-stepper-content step="4">
        <conyuge v-if="e6 === '4'"></conyuge>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '3'; changeStep();"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
          <v-btn color="accent" @click="e6 = '5'; changeStep();"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step step="5" :editable='true' @click='changeStep()'>Cargos Anteriores del Declarante</v-stepper-step>
      <v-stepper-content step="5">
        <cargos-anteriores v-if="e6 === '5'"></cargos-anteriores>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = ev; changeStep();"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
        </v-flex>
      </v-stepper-content>
    </v-stepper>
    <v-layout align-center wrap>
      <v-flex md8 />
      <v-flex xs3 offset-xs9 align-end>
        <v-btn color="secondary" @click="changeStep(), $router.push('/declaracion')"><v-icon right dark>arrow_back_ios</v-icon>&nbsp;Anterior</v-btn>
        <v-btn color="accent" @click="changeStep(), $router.push('/bienes')">Siguiente&nbsp;<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
      </v-flex>
    </v-layout>
  </section>
</template>
<script>
import DatosDeclaracion from '@/components/datosGenerales/datosDeclaracion';
import DatosPersonales from '@/components/datosGenerales/datosPersonales';
import CargoOcupara from '@/components/datosGenerales/cargoOcupara';
import Conyuge from '@/components/datosGenerales/conyuge';
import CargosAnteriores from '@/components/datosGenerales/cargosAnteriores';
import Parametricas from '../djbrd/mixins/parametricas';
export default {
  mixins: [ Parametricas ],
  mounted () {
    this.$root.$on('clickedEstCivil', () => {
      this.obtenerEstadoCivil().then(respuesta => {
        if (respuesta.finalizado) {
          if (respuesta.data.estciv_codigo === 1 || respuesta.data.estciv_codigo === 6) {
            this.edita = true;
            this.ev = '4';
            this.ee = '4';
          } else {
            this.edita = false;
            this.ev = '3';
            this.ee = '5';
          }
        }
      });
    });
  },
  created () {
    // this.navBarEmmit();
    this.obtenerEstadoDeclaracion().then(respuesta => {
      if (respuesta.finalizado) {
        if (respuesta.data.cod_estado === 3) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === 2) {
          this.$message['warning']('Su última Declaración no fue recepcionada, habilite la misma para terminarla');
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === -1) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
      }
    });
    this.obtenerEstadoCivil().then(respuesta => {
      if (respuesta.finalizado) {
        if (respuesta.data.estciv_codigo === 1 || respuesta.data.estciv_codigo === 6) {
          this.edita = true;
          this.ev = '4';
          this.ee = '4';
        } else {
          this.edita = false;
          this.ev = '3';
          this.ee = '5';
        }
      }
    });
    let ctrl = {
      datos_generales: {
        datos_declaracion: false,
        datos_personales: false,
        cargo_ocupara: false,
        conyuge: false
      }
    };
    this.$storage.set('ctrl', ctrl);
  },
  components: {
    DatosDeclaracion,
    DatosPersonales,
    CargoOcupara,
    Conyuge,
    CargosAnteriores
  },
  data () {
    return {
      e6: '1',
      ev: '4',
      ee: '4',
      edita: false
    };
  },
  methods: {
    changeStep () {
      let ctrl = this.$storage.get('ctrl');
      if (ctrl.datos_generales.datos_declaracion) {
        // this.$message['warning']('Datos Generales, esta editado pero aun no se ha guardo.');
        this.guardarDatosDeclaracionEmmit();
      }
      if (ctrl.datos_generales.datos_personales) {
        // this.$message['warning']('Datos Personales, esta editado pero aun no se ha guardo.');
        this.guardarDatosPersonalesEmmit();
      }
      if (ctrl.datos_generales.cargo_ocupara) {
        // this.$message['warning']('Cargo que Ocupara, esta editado pero aun no se ha guardo.');
        this.guardarCargoOcuparaEmmit();
      }
      if (ctrl.datos_generales.conyuge) {
        // this.$message['warning']('Conyuge, esta editado pero aun no se ha guardo.');
        this.guardarConyugeEmmit();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/declaracion/datosGenerales.vue